import { defineStore } from 'pinia'

import type { ChangelogStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useChangelogStore = defineStore('changelog', {
  state: (): ChangelogStore => ({
    loading: false,
    actions: [],
    meta: null,
    filterSearch: null,
    filterFrom: null,
    filterTo: null,
    perPage: 25,
    cursor: null,
    expandedActionId: null,
    items: [],
    itemsLoading: false,
  }),
  actions,
  getters,
})
